import React from 'react';
import { ViewerTemplate } from '../ViewerTemplate';
import { IOtherTitleFeeConfigurationData } from 'types/administration/pricing/underwriterProfileInterfaces/IOtherTitleFeeConfiguration';
import { BodyText } from 'ui-toolkit/components';
import { snakeCaseToCapitalize } from 'utilities/shared/stringMethods/stringMethods';
import { TransactionTypesViewer } from '../shared/TransactionTypesViewer';
import { pluralize, isPluralArray } from 'utilities/shared/stringMethods/pluralize';
import { KeyObjectViewer, LabelValueViewer } from '../shared/LabelValueViewer';
import { GrayCard } from '../shared/GrayCard';

export const OtherTitleFeesViewer: React.FC<{ otherTitleFeeConfig: IOtherTitleFeeConfigurationData[] }> = ({
  otherTitleFeeConfig,
}) => (
  <ViewerTemplate viewerName={'Other Title Fees:'}>
    <BodyText>
      {`There ${pluralize(isPluralArray(otherTitleFeeConfig), 'is', 'are')} ${
        otherTitleFeeConfig.length
      } other title fee${pluralize(isPluralArray(otherTitleFeeConfig))}`}
    </BodyText>
    {otherTitleFeeConfig.map((otherTitleFee) => (
      <GrayCard
        title={snakeCaseToCapitalize(otherTitleFee.titleFee)}
        isCollapsible
        key={otherTitleFee.titleFee + otherTitleFee.fee}
      >
        <LabelValueViewer label={'Fee'} value={otherTitleFee.fee} />
        <KeyObjectViewer label={'Transaction Types'}>
          <TransactionTypesViewer transactionTypes={otherTitleFee.transactionTypes} />
        </KeyObjectViewer>
      </GrayCard>
    ))}
  </ViewerTemplate>
);
